import PrimaryButton from '../buttons/PrimaryButton'
import Pencil from '../icons/Pencil'
import SecondaryButton from '../buttons/SecondaryButton'
import Setting from '../icons/Setting'
import Loading from "./Loading";
import React, { useState } from 'react'
import UpdateProfile from './UpdateProfile'
import CustomModal from './CustomModal'

const ProfileSection = ({ avatarUrl, profile, setReloadProfile }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const avatarReplace = () => {
    return avatarUrl
      ? avatarUrl?.replace('.glb', '.png')
      : '/images/avatar_default.png'
  }

  const closeEditModal = () => setIsEditModalOpen(false)

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-8">
      <div className="relative h-20 md:h-full">
        <div className="w-36 h-36 rounded-full overflow-hidden bg-gray-300 absolute md:static top-[-72px] z-10">
          {avatarUrl ? (
            <img
              className="w-48 max-w-48 h-auto object-cover object-[-20px]"
              src={avatarReplace()}
              alt="avatar"
            />
          ): (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loading />
            </div>
          )}
        </div>
        <div className="bg-primary absolute left-28 bottom-2 rounded-full z-20 w-9 h-9 flex justify-center items-center cursor-pointer">
          <Pencil color="white" height="20" width="20" />
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-2">
          <p className="text-lg font-bold">{profile && profile.real_email}</p>
          <p className="text-xs">
            I’m excited to make a difference in the world 🚀
          </p>
        </div>
        <div className="mt-4 flex gap-2">
          <SecondaryButton className="flex w-60 gap-2" onClick={() => setIsEditModalOpen(true)}>
            <Pencil color="white" height="20" width="20" /> Edit profile
          </SecondaryButton>
          <SecondaryButton
            className="flex w-60 gap-2 md:hidden"
            to="/update-avatar"
          >
            <Setting color="white" height="20" width="20" /> Edit avatar
          </SecondaryButton>
        </div>
      </div>

      <CustomModal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <UpdateProfile
          setIsEditModalOpen={setIsEditModalOpen}
          real_email={profile.real_email}
          setReloadProfile={setReloadProfile}
        />
      </CustomModal>
    </div>
  )
}

export default ProfileSection
